export * from './bo-property-inline.component';
export * from './bo-property-inline.module';

